import { useRef, useEffect, useState } from 'react';
import { Carousel, useBreakpoint, Breakpoints } from '@nextgen-web-framework/all';
import FeaturedArticle from '../FeaturedArticle/FeaturedArticle';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import type { FeaturedArticleCarousalComponentProps } from './types/propsType';
import styles from './FeaturedArticleCarousalComponent.module.scss';

const FeaturedArticleCarousalComponent = (props: FeaturedArticleCarousalComponentProps) => {
  const viewport = useBreakpoint();
  const isMobile = [Breakpoints.SM, Breakpoints.XS].includes(viewport as Breakpoints);
  const isDesktop = [Breakpoints.LG, Breakpoints.XL].includes(viewport as Breakpoints);
  const ref = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState(0);
  const [carouselLoading, setCarouselLoading] = useState(true);

  useEffect(() => {
    const getwidth = () => {
      const divWidth = ref.current?.getBoundingClientRect().width ?? 1116;
      const itemSize = isDesktop ? 0.82 : 0.92;
      setWidth(divWidth * itemSize);
      setCarouselLoading(false);
    };
    getwidth();
    window.addEventListener('resize', getwidth);
    return () => window.removeEventListener('resize', getwidth);
  }, []);

  return (
    <div className={`${styles['featured-article-container']}`} data-testid="featured-article-caraousal-container">
      <h2 className={styles['featured-article-carousal-title']}>{props.featuredArticleCarousalTitle}</h2>
      <div className={`${styles['featured-article-carousal-container']}`}>
        <div ref={ref}>
          {!carouselLoading && (
            <Carousel id={`featured-article-carousel`} isTileCarousel={true} data-testid="featured-article-caraousal">
              {props.featuredArticleCarousalItems.map((featuredArticle) => (
                <div
                  key={featuredArticle.brandTitle}
                  className={`${styles['featured-article-carousal-item']}`}
                  style={{ width: isMobile ? '100%' : width }}
                >
                  <FeaturedArticle {...featuredArticle} />
                </div>
              ))}
            </Carousel>
          )}
        </div>
        {carouselLoading && <SkeletonLoader height={300} borderRadius={12} />}
      </div>
    </div>
  );
};

export default FeaturedArticleCarousalComponent;

export type { FeaturedArticleCarousalComponentProps };
